import React from 'react';
import './FEFeatures.css';

const features = [
    {
        icon: 'fas fa-file-invoice',
        title: 'Emisión de e-CF',
        description:
            'Genera Comprobantes Fiscales Electrónicos con firma digital y formato XML estandarizado, según el Decreto 254-06 y la Ley 32-23.',
    },
    {
        icon: 'fas fa-file-invoice-dollar',
        title: 'Reportes 606, 607 y 608',
        description:
            'Genera y envía los formatos de compras, ventas y anulaciones directamente a la DGII con un solo clic, sin errores manuales.',
    },
    {
        icon: 'fas fa-cash-register',
        title: 'POS Punto de Venta',
        description:
            'Sistema de punto de venta integrado con facturación electrónica. Cada venta genera su e-CF automáticamente.',
    },
    {
        icon: 'fas fa-address-book',
        title: 'CRM de Clientes',
        description:
            'Gestiona tu cartera de clientes con validación de RNC automática, historial de compras y cuentas por cobrar.',
    },
    {
        icon: 'fas fa-signature',
        title: 'Firma Digital Certificada',
        description:
            'Firma digital basada en certificados emitidos por entidades autorizadas por INDOTEL, según la Ley 126-02. Incluida en todos los planes.',
    },
    {
        icon: 'fas fa-sync-alt',
        title: 'Conciliación Bancaria',
        description:
            'Sincroniza tus cuentas bancarias y concilia transacciones automáticamente. Control total de gastos menores y pagos al exterior.',
    },
];

const FEFeatures = () => {
    return (
        <section id="fe-features" className="fe-features">
            <div className="container">
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-7 text-center">
                        <span className="fe-features__label">Funcionalidade de nuestro ERP</span>
                        <h2 className="fe-features__heading">
                            Contabilidad + Facturación electrónica, POS, CRM y otros módulos en un solo lugar
                        </h2>
                        <p className="fe-features__subheading">
                            Todo lo que tu negocio necesita para cumplir con la DGII y la Ley 32-23.
                            Diseñado para contribuyentes grandes, medianos, pequeños y microempresas.
                        </p>
                    </div>
                </div>

                <div className="row">
                    {features.map((feature, index) => (
                        <div
                            key={index}
                            className="col-md-4 mb-4"
                        >
                            <div className="fe-feature-card">
                                <div className="fe-feature-card__icon-wrap">
                                    <i className={feature.icon}></i>
                                </div>
                                <h4 className="fe-feature-card__title">{feature.title}</h4>
                                <p className="fe-feature-card__description">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FEFeatures;
